module.exports = __webpack_public_path__ + "static/media/bgcPreparation.04c08592.png";